export default {
	// border-colors
	tableBorderColor: '#e8e8e8',

	// background-colors
	tableHead: '#fafafa',

	// solid-colors
	white: '#fff',

	// theme-colors
	primary: '#1890ff',
	editing: '#f0ad4e',
	viewing: '#5cb85c',
	background: '#eee',
	text: '#333',
	hoverBackground: '#ccc',
	hoverLink: '#096dd9',
	blackTheme: '#2d373c',
};
